"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _underscore = require("underscore");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIDialogCloseButton = _interopRequireDefault(require("UIComponents/dialog/UIDialogCloseButton"));

var _UIDialogHeader = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeader"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var _UIForm = _interopRequireDefault(require("UIComponents/form/UIForm"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UIAccordionItem = _interopRequireDefault(require("UIComponents/accordion/UIAccordionItem"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _ContactProperties = require("lead-flows-ui/constants/ContactProperties");

var _ContactPropertyFieldType = _interopRequireDefault(require("lead-flows-ui/components/editor/contactProperties/ContactPropertyFieldType"));

var _ContactPropertyOptions = _interopRequireDefault(require("lead-flows-ui/components/editor/contactProperties/ContactPropertyOptions"));

var _ContactProperty = _interopRequireDefault(require("lead-flows-ui/lib/ContactProperty"));

var _ContactPropertyUtils = require("lead-flows-ui/utils/ContactPropertyUtils");

var _FormFields = require("lead-flows-ui/constants/FormFields");

var RequestState = _interopRequireWildcard(require("lead-flows-ui/utils/RequestState"));

var NAME_ERRORS = [_ContactProperties.ErrorTypes.NAME_TOO_LONG, _ContactProperties.ErrorTypes.INVALID_NAME, _ContactProperties.ErrorTypes.DUPLICATED_NAME, _ContactProperties.ErrorTypes.EMPTY_NAME];
var OPTIONS_ERRORS = [_ContactProperties.ErrorTypes.SURROUNDING_WHITESPACE_OPTION, _ContactProperties.ErrorTypes.NON_UNIQUE_OPTION, _ContactProperties.ErrorTypes.SEMICOLON_OPTION];
var LABEL_ERRORS = [_ContactProperties.ErrorTypes.EMPTY_LABEL];
var FRONTEND_ERRORS = [].concat(LABEL_ERRORS, [_ContactProperties.ErrorTypes.EMPTY_OPTION]);
var BACKEND_ERRORS = [].concat(NAME_ERRORS, OPTIONS_ERRORS);

var ContactPropertyCreatePropertyModal =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(ContactPropertyCreatePropertyModal, _React$PureComponent);
  (0, _createClass2.default)(ContactPropertyCreatePropertyModal, null, [{
    key: "propTypes",
    get: function get() {
      return {
        contactPropertyGroupsByName: _react.PropTypes.array.isRequired,
        handleModalConfirm: _react.PropTypes.func.isRequired,
        handleModalReject: _react.PropTypes.func.isRequired,
        errorMessage: _react.PropTypes.string.isRequired,
        requestState: _react.PropTypes.instanceOf(RequestState.RequestState).isRequired
      };
    }
  }]);

  function ContactPropertyCreatePropertyModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ContactPropertyCreatePropertyModal);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ContactPropertyCreatePropertyModal).call(this));
    _this.state = {
      contactProperty: new _ContactProperty.default({
        groupName: 'contactinformation',
        fieldType: _FormFields.FieldTypes.TEXT
      }),
      errors: {}
    };
    _this.handleLabelChange = _this.handleLabelChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleFieldTypeChange = _this.handleFieldTypeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCurrencyCheckboxChange = _this.handleCurrencyCheckboxChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOptionsChange = _this.handleOptionsChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleInternalNameChange = _this.handleInternalNameChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDescriptionChange = _this.handleDescriptionChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleGroupNameChange = _this.handleGroupNameChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleModalConfirm = _this.handleModalConfirm.bind((0, _assertThisInitialized2.default)(_this));
    _this.isPropertyValidAndUpdateValidation = _this.isPropertyValidAndUpdateValidation.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(ContactPropertyCreatePropertyModal, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _underscore.isEmpty)(nextProps.errorMessage) && this.props.errorMessage !== nextProps.errorMessage) {
        var errors = this.state.errors;
        var frontendOnlyErrors = (0, _underscore.omit)(errors, BACKEND_ERRORS);
        this.setState({
          errors: Object.assign({}, frontendOnlyErrors, this.maybeGetNewError(nextProps.errorMessage))
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.handleModalReject();
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(path) {
      return "leadFlowEditor.contactProperties.createNew." + path;
    }
  }, {
    key: "maybeGetNewError",
    value: function maybeGetNewError(errorMessage) {
      var type = this.maybeGetErrorType(errorMessage);
      var subject = this.maybeGetErrorSubject(errorMessage);

      if ((0, _underscore.isEmpty)(type)) {
        return {};
      }

      return (0, _defineProperty2.default)({}, type, subject);
    }
  }, {
    key: "maybeGetErrorSubject",
    value: function maybeGetErrorSubject(errorMessage) {
      var foundSubjects = errorMessage.match(/'(.*?)'/);
      return foundSubjects ? foundSubjects[1] : '';
    }
  }, {
    key: "maybeGetErrorType",
    value: function maybeGetErrorType(errorMessage) {
      var errorFound = _ContactProperties.ErrorTypes.NOT_FOUND;
      Object.keys(_ContactProperties.ErrorReceivedToErrorType).forEach(function (error) {
        if (errorMessage.indexOf(error) !== -1) {
          errorFound = _ContactProperties.ErrorReceivedToErrorType[error];
        }
      });
      return errorFound;
    }
  }, {
    key: "handleLabelChange",
    value: function handleLabelChange(_ref2) {
      var target = _ref2.target;
      var contactProperty = this.state.contactProperty;
      var value = target.value,
          defaultValue = target.defaultValue;
      var updatedProperty = {
        label: value
      }; // update internal name if the previous label is the same than the current internal name

      if ((0, _ContactPropertyUtils.labelToName)(defaultValue) === contactProperty.name) {
        updatedProperty.name = (0, _ContactPropertyUtils.labelToName)(value);
      }

      this.updateContactProperty(updatedProperty);
    }
  }, {
    key: "handleFieldTypeChange",
    value: function handleFieldTypeChange(_ref3) {
      var value = _ref3.target.value;
      this.updateContactProperty({
        fieldType: value
      });
    }
  }, {
    key: "getDisplayedErrors",
    value: function getDisplayedErrors(errorTypes) {
      var errors = this.state.errors;
      return errorTypes.filter(function (errorType) {
        return errors.hasOwnProperty(errorType);
      }).map(function (errorType) {
        return {
          key: _ContactProperties.ErrorTypeLabels[errorType],
          subject: errors[errorType]
        };
      });
    }
  }, {
    key: "handleCurrencyCheckboxChange",
    value: function handleCurrencyCheckboxChange(_ref4) {
      var checked = _ref4.target.checked;
      this.updateContactProperty({
        showCurrencySymbol: checked
      });
    }
  }, {
    key: "handleOptionsChange",
    value: function handleOptionsChange(newOptions) {
      this.updateContactProperty({
        options: newOptions
      });
    }
  }, {
    key: "handleInternalNameChange",
    value: function handleInternalNameChange(_ref5) {
      var value = _ref5.target.value;
      this.updateContactProperty({
        name: value
      });
    }
  }, {
    key: "handleDescriptionChange",
    value: function handleDescriptionChange(_ref6) {
      var value = _ref6.target.value;
      this.updateContactProperty({
        description: value
      });
    }
  }, {
    key: "handleGroupNameChange",
    value: function handleGroupNameChange(_ref7) {
      var value = _ref7.target.value;
      this.updateContactProperty({
        groupName: value
      });
    }
  }, {
    key: "updateContactProperty",
    value: function updateContactProperty(newValues) {
      this.setState({
        contactProperty: new _ContactProperty.default(Object.assign({}, this.state.contactProperty, newValues))
      });
    }
  }, {
    key: "isPropertyValidAndUpdateValidation",
    value: function isPropertyValidAndUpdateValidation() {
      var errors = this.state.errors;
      var optionsValidity = this.checkOptionsValidity();
      var labelValidity = this.checkLabelValidity();
      var isOptionsValid = (0, _underscore.isEmpty)(Object.keys(optionsValidity));
      var isLabelValid = (0, _underscore.isEmpty)(Object.keys(labelValidity));
      var backendOnlyErrors = (0, _underscore.omit)(errors, FRONTEND_ERRORS);
      this.setState({
        errors: Object.assign({}, backendOnlyErrors, labelValidity)
      });
      return isOptionsValid && isLabelValid;
    }
  }, {
    key: "checkLabelValidity",
    value: function checkLabelValidity() {
      var contactProperty = this.state.contactProperty;

      if (contactProperty.label.length === 0) {
        return (0, _defineProperty2.default)({}, _ContactProperties.ErrorTypes.EMPTY_LABEL, '');
      }

      return {};
    }
  }, {
    key: "checkOptionsValidity",
    value: function checkOptionsValidity() {
      var contactProperty = this.state.contactProperty;
      var invalidOptions = (0, _underscore.some)(contactProperty.options, function (option) {
        return option.value === '';
      });

      if (invalidOptions) {
        return (0, _defineProperty2.default)({}, _ContactProperties.ErrorTypes.EMPTY_OPTION, '');
      }

      return {};
    }
  }, {
    key: "handleModalConfirm",
    value: function handleModalConfirm() {
      if (this.isPropertyValidAndUpdateValidation()) {
        this.props.handleModalConfirm(this.state.contactProperty);
      }
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(contactProperty) {
      var label = contactProperty.label;
      var errorMessage = '';
      var maybeLabelErrors = this.getDisplayedErrors(LABEL_ERRORS);

      if (maybeLabelErrors.length === 0) {
        maybeLabelErrors = this.getDisplayedErrors(NAME_ERRORS);
      }

      if (maybeLabelErrors.length > 0) {
        errorMessage = maybeLabelErrors.map(function (error) {
          return _react.default.createElement(_FormattedMessage.default, {
            message: error.key,
            options: {
              propertyName: error.subject
            }
          });
        });
      }

      return _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('inputs.label.label')
        }),
        error: maybeLabelErrors.length > 0,
        validationMessage: errorMessage
      }, _react.default.createElement(_UITextInput.default, {
        value: label,
        onChange: this.handleLabelChange,
        onBlur: this.isPropertyValidAndUpdateValidation
      }));
    }
  }, {
    key: "renderFieldType",
    value: function renderFieldType(contactProperty) {
      var fieldType = contactProperty.fieldType;
      return _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('inputs.fieldType.label')
        })
      }, _react.default.createElement(_ContactPropertyFieldType.default, {
        value: fieldType,
        handleChange: this.handleFieldTypeChange,
        handleBlur: this.isPropertyValidAndUpdateValidation
      }));
    }
  }, {
    key: "renderCurrencyCheckbox",
    value: function renderCurrencyCheckbox(contactProperty) {
      var fieldType = contactProperty.fieldType,
          showCurrencySymbol = contactProperty.showCurrencySymbol;

      if (fieldType === _FormFields.FieldTypes.NUMBER) {
        return _react.default.createElement("div", {
          className: "m-top-4"
        }, _react.default.createElement(_UICheckbox.default, {
          checked: showCurrencySymbol,
          onChange: this.handleCurrencyCheckboxChange
        }, _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('inputs.currencyCheckbox.label')
        })));
      }

      return null;
    }
  }, {
    key: "renderFieldOptions",
    value: function renderFieldOptions(contactProperty) {
      var fieldType = contactProperty.fieldType,
          options = contactProperty.options;
      var errorMessage = '';
      var errorSubject = '';
      var maybeOptionsErrors = this.getDisplayedErrors(OPTIONS_ERRORS);

      if (maybeOptionsErrors.length > 0) {
        errorMessage = maybeOptionsErrors.map(function (error) {
          return _react.default.createElement(_FormattedMessage.default, {
            message: error.key,
            options: {
              optionLabel: error.subject
            }
          });
        });
        errorSubject = maybeOptionsErrors.map(function (error) {
          return error.subject;
        });
      }

      if (_ContactProperties.FieldTypesWithOptions.hasOwnProperty(fieldType)) {
        return _react.default.createElement("div", {
          className: "m-left-6 m-top-2"
        }, _react.default.createElement(_ContactPropertyOptions.default, {
          handleChange: this.handleOptionsChange,
          handleBlur: this.isPropertyValidAndUpdateValidation,
          options: options,
          errorMessage: errorMessage,
          errorSubject: errorSubject
        }));
      }

      return null;
    }
  }, {
    key: "getOptionsForGroupName",
    value: function getOptionsForGroupName() {
      var contactPropertyGroupsByName = this.props.contactPropertyGroupsByName;
      return Object.values(contactPropertyGroupsByName || {}).map(function (group) {
        return {
          text: group.displayName,
          value: group.name
        };
      });
    }
  }, {
    key: "renderAdvancedOptions",
    value: function renderAdvancedOptions(contactProperty) {
      var name = contactProperty.name,
          description = contactProperty.description,
          groupName = contactProperty.groupName;
      var errorMessage = '';
      var maybeNameErrors = this.getDisplayedErrors(NAME_ERRORS);

      if (maybeNameErrors.length > 0) {
        errorMessage = maybeNameErrors.map(function (error) {
          return _react.default.createElement(_FormattedMessage.default, {
            message: error.key,
            options: {
              propertyName: error.subject
            }
          });
        });
      }

      return _react.default.createElement(_UIAccordionItem.default, {
        title: "Advanced options",
        className: "m-top-6",
        contentClassName: "m-top-0 m-bottom-4"
      }, _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('inputs.internalName.label')
        }),
        error: maybeNameErrors.length > 0,
        validationMessage: errorMessage
      }, _react.default.createElement(_UITextInput.default, {
        value: name,
        onChange: this.handleInternalNameChange
      })), _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('inputs.description.label')
        }),
        help: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('inputs.description.helperText')
        })
      }, _react.default.createElement(_UITextInput.default, {
        value: description,
        onChange: this.handleDescriptionChange
      })), _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('inputs.groupName.label')
        })
      }, _react.default.createElement(_UISelect.default, {
        options: this.getOptionsForGroupName(),
        value: groupName,
        onChange: this.handleGroupNameChange
      })));
    }
  }, {
    key: "renderForm",
    value: function renderForm(contactProperty) {
      return _react.default.createElement(_UIForm.default, null, this.renderLabel(contactProperty), this.renderFieldType(contactProperty), this.renderCurrencyCheckbox(contactProperty), this.renderFieldOptions(contactProperty), this.renderAdvancedOptions(contactProperty));
    }
  }, {
    key: "render",
    value: function render() {
      var contactProperty = this.state.contactProperty;
      var requestState = this.props.requestState;
      return _react.default.createElement(_UIModal.default, {
        width: 500
      }, _react.default.createElement(_UIDialogCloseButton.default, {
        onClick: this.props.handleModalReject
      }), _react.default.createElement(_UIDialogHeader.default, null, _react.default.createElement("h4", null, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('header')
      }))), _react.default.createElement(_UIDialogBody.default, null, this.renderForm(contactProperty)), _react.default.createElement(_UIDialogFooter.default, null, _react.default.createElement(_UIButton.default, {
        onClick: this.handleModalConfirm,
        use: "primary",
        disabled: requestState.isPending()
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('save')
      })), _react.default.createElement(_UIButton.default, {
        onClick: this.props.handleModalReject
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('cancel')
      }))));
    }
  }], [{
    key: "defaultProps",
    get: function get() {
      return {
        contactPropertyGroupsByName: []
      };
    }
  }]);
  return ContactPropertyCreatePropertyModal;
}(_react.default.PureComponent);

exports.default = ContactPropertyCreatePropertyModal;
module.exports = exports.default;